import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { newsItems } from "@/mocks/newsData";

export default function PressHero() {
  const launchArticle = newsItems.find((n) => n.id === "tie-officially-launched");

  return (
    <section className="relative overflow-hidden bg-tie-navy">
      {/* Background image */}
      <div className="absolute inset-0">
        {launchArticle?.image && (
          <img
            src={launchArticle.image}
            alt=""
            className="w-full h-full object-cover opacity-30"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-tie-navy/70 via-tie-navy/80 to-tie-navy/95" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 pb-14 md:pb-20">
        {/* Top badge */}
        <ScrollReveal>
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide uppercase">
                / Official Press Releases
              </span>
            </div>
          </div>
        </ScrollReveal>

        {/* Main headline */}
        <ScrollReveal delay={100}>
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight text-center">
            Official Press Releases
          </h1>
        </ScrollReveal>
        <ScrollReveal delay={200}>
          <p className="mt-4 md:mt-5 text-base md:text-lg text-white/60 max-w-2xl mx-auto leading-relaxed text-center">
            Official announcements, partnership disclosures, and milestone updates from Textile Innovation Exchange.
          </p>
        </ScrollReveal>

        {/* Grand Launch spotlight card */}
        {launchArticle && (
          <ScrollReveal delay={300}>
            <div className="mt-10 md:mt-14 max-w-3xl mx-auto">
              <div className="relative rounded-2xl overflow-hidden border border-white/20 bg-white/5 backdrop-blur-sm">
                {/* Label */}
                <div className="absolute top-4 left-4 z-10 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/90 text-white text-xs font-semibold uppercase tracking-wider">
                    <i className="ri-star-fill text-[10px]" />
                    Grand Launch Coverage
                  </span>
                </div>

                <div className="flex flex-col md:flex-row">
                  {/* Image */}
                  <div className="relative w-full md:w-56 h-44 md:h-auto shrink-0 overflow-hidden">
                    <img
                      src={launchArticle.image}
                      alt={launchArticle.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-tie-navy/30 hidden md:block" />
                  </div>

                  {/* Content */}
                  <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                    <div className="flex items-center gap-3 text-xs text-white/50 mb-2">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-calendar-line" />
                        {launchArticle.date}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-time-line" />
                        {launchArticle.readTime}
                      </span>
                      <span className="text-tie-teal-light font-medium">
                        {launchArticle.source}
                      </span>
                    </div>
                    <h2 className="text-base md:text-lg font-semibold text-white leading-snug mb-3">
                      {launchArticle.title}
                    </h2>
                    <p className="text-sm text-white/60 leading-relaxed line-clamp-2 mb-4">
                      {launchArticle.excerpt}
                    </p>
                    <Link
                      to={`/press-release/${launchArticle.id}`}
                      className="inline-flex items-center gap-2 text-sm font-semibold text-tie-teal-light hover:underline whitespace-nowrap w-fit cursor-pointer"
                    >
                      Read Full Coverage
                      <i className="ri-arrow-right-line text-xs opacity-70" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}